module.exports = __webpack_public_path__ + "img/how-it-works-6.9394b5ac.svg";